import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const FOMENTINDEX_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FomentIndex.Name')
    .required()
    .minLength(1)
    .maxLength(30)
    .build(),
];

export const FOMENTINDEX_CONFIG = {
  entityName: 'FomentIndex',
  localizationKey: 'Controlling::Entity.FomentIndex',
  fields: FOMENTINDEX_FIELDS,
  permission: 'ControllingContract.FomentIndexes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
